export const displayMode = {
    display: '2',
    send: '3'
};
